module.exports = __webpack_public_path__ + "img/cm_s5-slc1-u.75d7f1c6.png";